// 投递状态常量定义
export const DELIVERY_STATUS_CODES = {
  // 有岗可约投 - 表示有职位可以投递
  AVAILABLE: '有岗可约投',
  // 岗位已投完 - 表示岗位已经投递完成
  COMPLETED: '岗位已投完',
  // 服务已完成 - 表示服务已经完成
  SERVICE_COMPLETED: '服务已完成',
  // 禁投看备注 - 表示禁止投递，需要查看备注
  FORBIDDEN: '禁投看备注',
  // 服务已冻结 - 表示服务被冻结
  FROZEN: '服务已冻结',
  // 已成功上岸 - 表示已经成功上岸
  SUCCESS: '已成功上岸'
};

// 待处理状态列表（用于统计待处理任务）
export const PENDING_DELIVERY_STATUSES = [
  DELIVERY_STATUS_CODES.AVAILABLE
];

// 投递状态颜色映射
export const DELIVERY_STATUS_COLORS = {
  [DELIVERY_STATUS_CODES.AVAILABLE]: '#67C23A',      // 绿色 - 有岗可约投
  [DELIVERY_STATUS_CODES.COMPLETED]: '#E6A23C',      // 橙色 - 岗位已投完
  [DELIVERY_STATUS_CODES.SERVICE_COMPLETED]: '#409EFF', // 蓝色 - 服务已完成
  [DELIVERY_STATUS_CODES.FORBIDDEN]: '#F56C6C',      // 红色 - 禁投看备注
  [DELIVERY_STATUS_CODES.FROZEN]: '#909399',         // 灰色 - 服务已冻结
  [DELIVERY_STATUS_CODES.SUCCESS]: '#13CE66'         // 深绿 - 已成功上岸
};

// 投递状态标签类型映射
export const DELIVERY_STATUS_TAG_TYPES = {
  [DELIVERY_STATUS_CODES.AVAILABLE]: 'success',
  [DELIVERY_STATUS_CODES.COMPLETED]: 'warning',
  [DELIVERY_STATUS_CODES.SERVICE_COMPLETED]: 'primary',
  [DELIVERY_STATUS_CODES.FORBIDDEN]: 'danger',
  [DELIVERY_STATUS_CODES.FROZEN]: 'info',
  [DELIVERY_STATUS_CODES.SUCCESS]: 'success'
};

// 所有投递状态列表（用于下拉选择）
export const ALL_DELIVERY_STATUSES = [
  DELIVERY_STATUS_CODES.AVAILABLE,
  DELIVERY_STATUS_CODES.COMPLETED,
  DELIVERY_STATUS_CODES.SERVICE_COMPLETED,
  DELIVERY_STATUS_CODES.FORBIDDEN,
  DELIVERY_STATUS_CODES.FROZEN,
  DELIVERY_STATUS_CODES.SUCCESS
];

export default {
  DELIVERY_STATUS_CODES,
  PENDING_DELIVERY_STATUSES,
  DELIVERY_STATUS_COLORS,
  DELIVERY_STATUS_TAG_TYPES,
  ALL_DELIVERY_STATUSES
};
